import { motion } from 'framer-motion';

interface BookFilmGalleryProps {
  images: Array<{ pageName: string; url: string }>;
}

export function BookFilmGallery({ images }: BookFilmGalleryProps) {
  // Filter out cover images, show story pages only
  const storyImages = images.filter(
    img => img?.url && img?.pageName && !img.pageName.toLowerCase().includes('cover')
  );

  if (storyImages.length === 0) return null;

  return (
    <div className="py-3">
      <h3 className="text-sm font-semibold text-white/60 uppercase tracking-wider mb-3">
        Scenes
      </h3>
      <div
        className="flex gap-2.5 overflow-x-auto pb-2 scrollbar-hide -mx-5 px-5 lg:-mx-12 lg:px-12"
        style={{ scrollbarWidth: 'none', WebkitOverflowScrolling: 'touch' }}
      >
        {storyImages.map((img, index) => (
          <motion.div
            key={img.pageName}
            className="flex-shrink-0"
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.04, duration: 0.3 }}
          >
            <div className="w-44 md:w-56 aspect-video rounded-lg overflow-hidden bg-white/5 ring-1 ring-white/10">
              <img
                src={img.url}
                alt={`Scene from ${img.pageName}`}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
